import IconButton from "components/IconButton";
import AddressItem from "components/Addresses/components/AddressItem";
import ButtonRow from "components/ButtonRow";
import Icon from "components/Icon/Icon";
import { Content } from "containers/RightPanel/RightPanel.styles";
import styled from "styled-components";
import { HeaderTitle } from "styles/outgoingStyles";

// The details scroll above the footer, which keeps its own height: on a phone
// its button wraps below the total.
export const PanelLayout = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

// The drawer's own white under a hairline: what the parcel costs on the left,
// its action on the right, where every drawer keeps its primary.
export const Footer = styled.div`
  flex: none;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  padding: 16px 15px;
  background-color: ${({ theme }) => theme.surfacePanel};
  border-top: 1px solid ${({ theme }) => theme.divider};
`;

export const Total = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TotalLabel = styled.span`
  font-size: 12px;
  line-height: 16px;
  color: ${({ theme }) => theme.textMuted};
`;

export const TotalAmount = styled.span`
  font-size: 18px;
  line-height: 24px;
  font-weight: 600;
  color: ${({ theme }) => theme.textMain};
  white-space: nowrap;
`;

// Never squeezed: when the total and the button do not fit on one line, the
// button moves to the next one instead of wrapping its label.
export const FooterActions = styled(ButtonRow).attrs({ $align: "end" })`
  flex: none;
  flex-wrap: nowrap;
  margin-left: auto;
`;

export const PanelAddressItem = styled(AddressItem)`
  width: 100%;
  padding: 8px 15px 0 25px;
  animation: none;
  border-bottom: none;

  p {
    white-space: pre;
  }
`;

// The scroll area takes whatever the footer leaves.
export const ContentWrapper = styled(Content)`
  flex: 1 1 0;
  min-height: 0;
  height: auto !important;
`;

export const ImageSection = styled.div`
  min-height: 358px;
  width: 100%;
`;

// The review button's chevron, in the label's colour.
export const NextChevron = styled(Icon)`
  width: 16px;
  height: 16px;
  background-color: currentColor;
`;

export const CancelIcon = styled(Icon)`
  width: 10px;
  height: 10px;
  background-color: currentColor;
`;

export const SKUTitle = styled(HeaderTitle)`
  color: ${({ theme }) => theme.black};
`;

export const CsvButton = styled(IconButton)`
  margin-left: 8px;
`;
